import React, { useEffect } from 'react';
import { css } from '@emotion/react';
import { Button } from '@uniquegood/realworld-studio-design';
import { ClickEventName, PageViewEventName, track } from '@/track';
import { useParamsWithMatchPath } from '@/hooks';

interface ErrorTemplateProps {
  onRetry?: () => void;
  onContact?: () => void;
  message?: string;
  errorCode?: string;
}

function ErrorTemplate({ onRetry, onContact, message, errorCode }: ErrorTemplateProps) {
  const { appId } = useParamsWithMatchPath();
  useEffect(() => {
    track.onPageViewMixpanel(PageViewEventName.view_newgame_ai_storyconfig_error, {
      channel_id: appId,
    });
  }, [appId]);
  return (
    <div css={Container}>
      <div css={ContentContainer}>
        <div css={ErrorMessageContainer}>
          <div css={Title}>앗! 잠시 문제가 생겼어요</div>
          <div css={Description}>{message ?? '문제가 계속될 경우 관리자에게 문의해주세요.'}</div>
        </div>
        {errorCode && <div css={ErrorCode}>에러 코드: {errorCode}</div>}
        <div css={ButtonsContainer}>
          <Button
            size="large"
            onClick={onContact ?? (() => {
              ChannelIO?.('showMessenger')
              track.onClick({
                clickEventName: ClickEventName.click_newgame_ai_storyconfig_contact,
                params: {
                  channel_id: appId,
                },
              });

            })}
            css={css`
              background: #ededed;
              border: none;
            `}
          >
            1:1 문의하기
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              onRetry?.()
              track.onClick({
                clickEventName: ClickEventName.click_newgame_ai_storyconfig_refresh,
                params: {
                  channel_id: appId,
                },
              });

            }}
            css={css`
              background: #7800ff;
              border: none;
            `}
          >
            새로고침
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ErrorTemplate;

const Container = css`
  width: 100%;
  height: calc(100vh - 62px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f4f4;
`;

const ContentContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  max-width: 1280px;
  padding: 0 24px;
`;

const ErrorMessageContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
`;

const Title = css`
  color: #0e1017;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
`;

const Description = css`
  color: #0e1017;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;

const ErrorCode = css`
  color: #797d88;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;

const ButtonsContainer = css`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;
